import { render } from "./viewRestrictions.html?vue&type=template&id=1c40d33f&scoped=true&ts=true&external"
import script from "./ViewRestrictions.vue?vue&type=script&lang=ts"
export * from "./ViewRestrictions.vue?vue&type=script&lang=ts"

import "./ViewRestrictions.vue?vue&type=style&index=0&id=1c40d33f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c40d33f"]])

export default __exports__